import { Link, useLocation } from 'react-router-dom';
import { MapPin } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useApp } from '../AppProvider.tsx';
import useAppLocation from '../useAppLocation.ts';
import type { NavLinkProps } from '@fastnorth/kraken/components/navigation';
import { useFollowing } from '../FollowingProvider.tsx';

const useFollowingLink = (): NavLinkProps | null => {
  const { t } = useTranslation('translation', { keyPrefix: 'karwa.components.navigation' });
  const [{ event, hasRacesWithPredictiveTracking }] = useApp();
  const { uniqueCode } = event || {};
  const { search } = useLocation();
  const { isFollowing } = useAppLocation();
  const [{ following = [] }] = useFollowing();

  if (!event || !hasRacesWithPredictiveTracking) {
    return null;
  }

  return {
    id: 'following',
    active: isFollowing,
    children: (
      <Link
        to={`/events/${uniqueCode}/following${search}`}
        className={'flex items-center'}
        data-dd-action-name={'link-following-nav_menu'}>
        <MapPin size={16} strokeWidth={2} className={'mr-4'} />
        {t('following_label', {
          follows: following.length && <span key="following-count">{following.length}</span>,
        })}
      </Link>
    ),
  };
};

export default useFollowingLink;
